import React from 'react';
import { Popover, Box, Button, Divider } from '@mui/material';
import CustomSelect from '../CustomSelect/CustomSelect';
import LabeledSelectField from '../CustomSelect/LabeledSelectField';

const SelectCategory = ({
	isOpen,
	handleChange,
	filterValue,
	top,
	left,
	handleClose,
	handleClear,
	filterOptions,
}: any) => {
	return (
		<Popover
			open={isOpen}
			onClose={handleClose}
			anchorReference="anchorPosition"
			anchorPosition={{ top: top + 45, left: left + 60 }}
			PaperProps={{
				sx: {
					backgroundColor: '#FDFDFD',
					borderRadius: '4px',
					boxShadow: '0px 10px 25px 0px #0000001A',
				},
			}}
			BackdropProps={{
				sx: {
					backgroundColor: 'transparent',
				},
			}}
		>
			<Box
				sx={{
					width: '293px',
					backgroundColor: '#FDFDFD',
					borderRadius: '4px',
					boxShadow: '0px 10px 25px 0px #0000001A',
				}}
			>
				<LabeledSelectField
					placeholder="Part Category"
					options={filterOptions}
					value={filterValue}
					handleChange={handleChange}
					styles={{ width: '265px', height: '36px', margin: '15px' }}
				/>
				<Divider />
				<Box
					sx={{
						display: 'flex',
						padding: '12px 14px',
						alignItems: 'center',
						justifyContent: 'flex-start',
					}}
				>
					<Button
						sx={{
							color: 'errorColor.main',
							p: 0,
							height: 'auto',
							justifyContent: 'flex-start',
							':hover': {
								backgroundColor: 'transparent',
							},
						}}
						disabled={filterValue === '' ? true : false}
						onClick={handleClear}
					>
						Clear
					</Button>
				</Box>
			</Box>
		</Popover>
	);
};

export default SelectCategory;
